"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageMetricId = void 0;
var PageMetricId;
(function (PageMetricId) {
    PageMetricId["ActivityRate"] = "activityRate";
    PageMetricId["BounceRate"] = "bounceRate";
    PageMetricId["ConversionRate"] = "conversionRate";
    PageMetricId["ElapsedTime"] = "elapsedTime";
    PageMetricId["ExitRate"] = "exitRate";
    PageMetricId["FoldHeight"] = "foldHeight";
    PageMetricId["InteractionTimeAverage"] = "interactionTimeAverage";
    PageMetricId["LandingRate"] = "landingRate";
    PageMetricId["LoadingTime"] = "loadingTime";
    PageMetricId["PageHeight"] = "pageHeight";
    PageMetricId["ScrollRate"] = "scrollRate";
    PageMetricId["UniqueUsers"] = "uniqueUsers";
    PageMetricId["ViewAverage"] = "viewAverage";
    PageMetricId["VisitCount"] = "visitCount";
    PageMetricId["ViewCount"] = "viewCount";
    PageMetricId["VisitRate"] = "visitRate";
})(PageMetricId = exports.PageMetricId || (exports.PageMetricId = {}));
//# sourceMappingURL=page-metric.js.map